import { render, staticRenderFns } from "./handitemqi.vue?vue&type=template&id=bb1b7fae"
import script from "./handitemqi.vue?vue&type=script&lang=js"
export * from "./handitemqi.vue?vue&type=script&lang=js"
import style0 from "./handitemqi.vue?vue&type=style&index=0&id=bb1b7fae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports